// Textarea/searchbox UI helpers

const textarea = document.getElementById('searchInput');
const exampleStrip = document.querySelector('.example-strip');
const chips = document.querySelectorAll('.chip');
const searchBtn = document.getElementById('searchBtn');

if (!textarea) {
    console.warn('[Searchbox] textarea element not found');
}

// Calculate the actual line height based on font-size and line-height
const fontSize = textarea ? parseFloat(getComputedStyle(textarea).fontSize) : 16;
const lineHeight = textarea ? parseFloat(getComputedStyle(textarea).lineHeight) : 24;
const paddingTop = textarea ? parseFloat(getComputedStyle(textarea).paddingTop) : 16;
const paddingBottom = textarea ? parseFloat(getComputedStyle(textarea).paddingBottom) : 16;

// Calculate heights for single-line growing textbox
const minHeight = fontSize * 1.5 + paddingTop + paddingBottom; // 1.5em + padding
const lineHeightPx = 24; // 24px per line

// Function to calculate max height (when scrollbar should appear)
function getMaxHeight() {
    if (!textarea) return 72 + paddingTop + paddingBottom;
    const computed = getComputedStyle(textarea);
    const paddingTop = parseFloat(computed.paddingTop);
    const paddingBottom = parseFloat(computed.paddingBottom);
    // 3 rows * 24px per line = 72px content + padding
    return 72 + paddingTop + paddingBottom;
}

function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export function adjustTextareaHeight() {
    if (!textarea) return;
    
    const computed = getComputedStyle(textarea);
    const paddingTop = parseFloat(computed.paddingTop);
    const paddingBottom = parseFloat(computed.paddingBottom);
    const borderTop = parseFloat(computed.borderTopWidth);
    const borderBottom = parseFloat(computed.borderBottomWidth);
    
    // Check if search box is bottom-positioned (for followups)
    const searchBox = document.getElementById('searchBox');
    const isBottomPositioned = searchBox && searchBox.classList.contains('bottom-positioned');
    const isFocused = document.activeElement === textarea;
    
    // Default height: 120px for initial screen (2 lines), 56px for bottom-positioned single-line pill
    const defaultHeight = isBottomPositioned ? 56 : 120;
    const computedLineHeight = parseFloat(computed.lineHeight) || 24;
    const heightIncrement = computedLineHeight; // Grow by one actual text line
    const maxHeight = getMaxHeight();
    const lineHeight = computedLineHeight; // Match textarea's computed line-height
  
    // Get current displayed height BEFORE setting to auto
    const currentHeight = parseFloat(computed.height) || defaultHeight;
    
    // Set to auto temporarily to measure actual content height
    textarea.style.setProperty("height", "auto", "important");
    let scrollHeight = textarea.scrollHeight;
  
    // iOS correction: add full borders + top+bottom padding once more if there's content
    const baseEmptyHeight = paddingTop + paddingBottom + borderTop + borderBottom;
    if (isIOS() && scrollHeight > baseEmptyHeight) {
        scrollHeight += paddingTop + paddingBottom + borderTop + borderBottom;
    }
    
    let finalHeight;
    let showScrollbar = false;
    
    // Check if textarea is empty
    if (!textarea.value.trim()) {
        // Empty: use default height
        finalHeight = defaultHeight;
    } else {
        // Calculate the number of lines based on scrollHeight
        const contentHeight = scrollHeight - paddingTop - paddingBottom - borderTop - borderBottom;
        const defaultContentHeight = defaultHeight - paddingTop - paddingBottom - borderTop - borderBottom;
        
        // Calculate total lines needed
        // Small epsilon to avoid off-by-one line growth from sub-pixel rendering.
        const epsilonPx = 0.75;
        const totalLines = Math.max(1, Math.ceil((contentHeight - epsilonPx) / lineHeight));
        
        // Growth behavior depends on whether bottom-positioned or not
        if (isBottomPositioned) {
            // Bottom-positioned: 1 line default (56px), grows from 2nd line onwards
            if (totalLines <= 1) {
                finalHeight = defaultHeight;
            } else {
                const additionalLines = totalLines - 1;
                const additionalHeight = additionalLines * heightIncrement;
                finalHeight = defaultHeight + additionalHeight;
            }
        } else {
            // Initial screen: grow from 3rd line onwards (2 lines default)
            if (totalLines <= 2) {
                finalHeight = defaultHeight;
            } else {
                const additionalLines = totalLines - 2;
                const additionalHeight = additionalLines * heightIncrement;
                finalHeight = defaultHeight + additionalHeight;
            }
        }
        
        // Ensure we don't exceed maxHeight
        if (finalHeight > maxHeight) {
            finalHeight = maxHeight;
            showScrollbar = true;
        }
    }
  
    textarea.style.setProperty("height", `${finalHeight}px`, "important");
    textarea.style.setProperty(
        "overflow",
        showScrollbar ? "auto" : "hidden",
        "important"
    );
    
    // Auto-scroll to bottom to show the text being typed above the buttons
    requestAnimationFrame(() => {
        textarea.scrollTop = textarea.scrollHeight;
        const cursorPosition = textarea.selectionStart;
        if (cursorPosition === textarea.value.length) {
            textarea.setSelectionRange(textarea.value.length, textarea.value.length);
        }
    });
    
    // Update button-row right gap when scrollbar is visible
    const buttonRow = document.querySelector('.textarea-wrapper .button-row');
    if (buttonRow) {
        if (showScrollbar) {
            buttonRow.style.right = '16px';
        } else {
            buttonRow.style.right = '';
        }
    }
    
    // Update scroll-to-bottom button position on small screens when textarea height changes
    if (window.innerWidth <= 650) {
        // Use requestAnimationFrame to ensure DOM has updated
        requestAnimationFrame(() => {
            const scrollToBottomBtn = document.getElementById('scrollToBottomBtn');
            const searchBox = document.getElementById('searchBox');
            
            if (scrollToBottomBtn && searchBox && searchBox.classList.contains('bottom-positioned')) {
                const searchBoxRect = searchBox.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                const spacing = 12; // Space between button and search box
                
                // Position button just above the search box
                const bottomPosition = windowHeight - searchBoxRect.top + spacing;
                scrollToBottomBtn.style.bottom = `${bottomPosition}px`;
            }
        });
    }
}

export function hideExampleStrip() {
    if (exampleStrip) exampleStrip.classList.add('hidden');
}

// moveHeaderBoxToTop is defined in pre/legacy.js and exposed via window.bms

// Initialize textarea height adjustment listeners
export function initSearchbox() {
    if (!textarea) return;
    
    // Run on user input and other content changes
    textarea.addEventListener('input', adjustTextareaHeight);
    textarea.addEventListener('paste', adjustTextareaHeight);
    textarea.addEventListener('keyup', adjustTextareaHeight);
    
    // Handle window resize to update max height and recalculate
    window.addEventListener('resize', adjustTextareaHeight);
    
    // Initialize textarea height on load
    window.addEventListener('load', () => {
        const searchBox = document.getElementById('searchBox');
        const isBottomPositioned = searchBox && searchBox.classList.contains('bottom-positioned');
        
        // Always set correct default height for bottom-positioned searchbox (minimal when not focused)
        if (isBottomPositioned) {
            if (!textarea.value.trim() && document.activeElement !== textarea) {
                textarea.style.setProperty("height", "56px", "important");
                textarea.style.setProperty("min-height", "56px", "important");
                textarea.style.setProperty("overflow", "hidden", "important");
                textarea.style.setProperty("padding-bottom", "14px", "important");
            }
        } else {
            if (!textarea.value.trim()) {
                textarea.style.setProperty("height", "120px", "important");
                textarea.style.setProperty("min-height", "120px", "important");
            }
        }
        
        adjustTextareaHeight();
        
        // Also ensure bottom-positioned searchbox is minimal when not focused
        if (isBottomPositioned && !textarea.value.trim() && document.activeElement !== textarea) {
            requestAnimationFrame(() => {
                textarea.style.setProperty("height", "56px", "important");
                textarea.style.setProperty("min-height", "56px", "important");
                textarea.style.setProperty("padding-bottom", "14px", "important");
                adjustTextareaHeight();
            });
        }
    });
    
    // Wire up chip and search button click handlers
    // Note: hideExampleStrip is now called in handleSearch after all checks pass
    chips.forEach(chip => {
        chip.addEventListener('click', () => {
            // Don't hide example strip here - let handleSearch handle it after checks
        });
    });
    
    if (searchBtn) {
        searchBtn.addEventListener('click', () => {
            if (textarea.value.trim()) {
                // Don't hide example strip here - let handleSearch handle it after checks
                // moveSearchBoxToBottom is called via bmsCall from pre bundle
            }
        });
    }
    
    // Wire Enter key in textarea
    // Note: hideExampleStrip is now called in handleSearch after all checks pass
    if (textarea) {
        textarea.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
                if (!textarea.value.trim()) {
                    return;
                }
                // Don't hide example strip here - let handleSearch handle it after checks
                // moveSearchBoxToBottom and handleSearch are called via bmsCall from pre bundle
            }
        });
        
        // Expand textarea when focused (bottom-positioned only)
        textarea.addEventListener('focus', () => {
            const searchBox = document.getElementById('searchBox');
            if (searchBox && searchBox.classList.contains('bottom-positioned')) {
                // Keep single-line height when focused (still grows with content)
                if (!textarea.value.trim()) {
                    textarea.style.setProperty("height", "56px", "important");
                    textarea.style.setProperty("min-height", "56px", "important");
                    textarea.style.setProperty("padding-bottom", "14px", "important");
                }
                adjustTextareaHeight();
            }
        });
        
        // Collapse textarea when blurred if empty (bottom-positioned only)
        textarea.addEventListener('blur', () => {
            const searchBox = document.getElementById('searchBox');
            if (searchBox && searchBox.classList.contains('bottom-positioned')) {
                // Collapse to single-line pill if empty
                if (!textarea.value.trim()) {
                    setTimeout(() => {
                        // Check focus again after a short delay (in case user clicked a button inside)
                        if (document.activeElement !== textarea) {
                            textarea.style.setProperty("height", "56px", "important");
                            textarea.style.setProperty("min-height", "56px", "important");
                            textarea.style.setProperty("padding-bottom", "14px", "important");
                            adjustTextareaHeight();
                        }
                    }, 150);
                }
            }
        });
    }
}
